var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-text-compose",class:{ 'alt-font': _vm.altFont }},[_c('div',{ref:"textEditor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }